module.exports = __webpack_public_path__ + "img/IMG_3346_2028_P_T_L_BlackMatted.71e741f6.jpg";